import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f2e322d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-time-estimate" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-time-estimate__label" }, "Окончательная оценка времени", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-time-estimate__label" }, "Оценка задачи по времени", -1))
const _hoisted_4 = {
  key: 0,
  class: "task-time-estimate__list"
}
const _hoisted_5 = {
  key: 1,
  class: "task-time-estimate__buttons"
}
const _hoisted_6 = { class: "employee-multiselect_footer" }

import { computed, PropType, ref, watch } from 'vue';
import { PerformerEstimatedModel } from '../../models';
import TaskTimeEstimateLi from './task-time-estimate-li.vue';
import TaskTimeEstimateInput from './task-time-estimate-input.vue';
import { TirPmButton, TirPmButtonSizeEnum, TirPmButtonVariantEnum } from 'tir-components';
import { PlusIcon, UserPlusIcon } from 'tir-style-system/icons/outline';
import { TaskTimeEstimateModeEnum } from './enums';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { EmployeeMultiselect } from '@/components';
import { AdapterService } from './adapter-service';
import { UserModel } from '@/components/task-forms/models';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from '../task-drawer/models/GetAccessCurrentUserInQueueTaskByIdResponseModel';

/**API сервис */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-time-estimate',
  props: {
  /**Разрешение на приглашение для оценки задачи */
  canInvite: { type: Boolean as PropType<boolean>, default: true },
  /**Список оценок по исполнителям */
  performersEstimated: { type: Array as PropType<Array<PerformerEstimatedModel>>, default: [] },
  /**Заблокировать */
  isDisabled: { type: Boolean, default: false },
  /**Id задачи */
  taskId: { type: Number },
  /**Может ли текущий пользователь выставлять итоговую оценку времени */
  canUpsertFinalEstimate: { type: Boolean },
  /**Финальная оценка */
  finalEstimatePerformer: { type: Object as PropType<PerformerEstimatedModel> },
  /**Оценка задачи */
  isEstimate: { type: Boolean },
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
},
  setup(__props) {

const props = __props;

const apiService = new AdapterService();

/**Параметры */


/**Режим */
const mode = ref(TaskTimeEstimateModeEnum.View);
/**Компонент выбора пользователей */
const $employeeMultiselect = ref<InstanceType<typeof EmployeeMultiselect>>();
/**Список сотрудников */
const employees = ref<UserModel[]>([]);
/**Приглашенные сотрудники */
const invitedEmployees = ref<number[]>([]);
/**Приглашение пользователей */
const isInviteLoading = ref(false);
/**Финальная оценка */
const finalEstimate = ref<PerformerEstimatedModel>();

/**Сменить режимм */
const changeMode = (_mode: TaskTimeEstimateModeEnum) => {
  mode.value = _mode;
};

/**Пользоватер овнер */
const isOwner = computed(() => CurrentUser.Roles.includes(UserRoleEnum.Owner));
/**Разрешено приглашение на оценку */
const allowInvite = computed(() => {
  return (
    !props.isEstimate &&
    (isOwner.value || props.userAccess.IsProjectAdmin || props.userAccess.IsNamespaceAdmin)
  );
});
/**Вариант кнопки */
const changeButtonVariant = computed(() => {
  if (props.canInvite) {
    return TirPmButtonVariantEnum.SecondaryState;
  } else {
    return TirPmButtonVariantEnum.PrimaryState;
  }
});
/**Показывать кнопку добавления оценки */
const showAddButton = computed(() => {
  return !props.performersEstimated.some((x) => x.Id == CurrentUser.Id && x.Estimate);
});
/**Отключена кнопка приглашения */
const inviteButtonDisabled = computed(() => {
  const alreadyInvited = props.performersEstimated?.map((x) => x.Id) || [];
  return (
    alreadyInvited.length == invitedEmployees.value.length &&
    alreadyInvited.every((x) => invitedEmployees.value.includes(x))
  );
});
/**Запрещено редактирование пользователей */
const isUsersEditDisabled = computed(() => props.performersEstimated.some((p) => p.IsEdit));

/**Отслеживание изменений финальной оценки */
watch(() => props.finalEstimatePerformer, setFinalEstimate, { deep: true, immediate: true });

/**Установка значения поля finalEstimate */
function setFinalEstimate() {
  console.log(props.finalEstimatePerformer);

  finalEstimate.value = props.finalEstimatePerformer;
}
/**Пригласить пользователей к оценке */
const inviteEstimate = async () => {
  isInviteLoading.value = true;

  const response = await apiService.inviteToEstimate(props.taskId, invitedEmployees.value);
  if (response.IsSuccess) {
    invitedEmployees.value.forEach((id) => {
      if (!props.performersEstimated.some((p) => p.Id == id)) {
        const employee = employees.value.find((e) => e.Id == id);
        if (employee) {
          props.performersEstimated.push(
            new PerformerEstimatedModel({
              Id: employee.Id,
              FirstName: employee.FirstName,
              LastName: employee.LastName,
              MiddleName: employee.MiddleName,
              AvatarColor: employee.AvatarColor,
              Foto: employee.ImageUrl,
            }),
          );
        }
      }
    });
  }

  isInviteLoading.value = false;
  closeEmployeeMultiselect();
};
/**Закрыть поповер выбора пользователей */
const closeEmployeeMultiselect = () => {
  $employeeMultiselect.value?.close?.();
};
/**Получение пользователей для приглашения */
const onOpenMultiselect = async () => {
  invitedEmployees.value = props.performersEstimated?.map((x) => x.Id) || [];
  const response = await apiService.getEmployeesForManagerList();
  if (response.IsSuccess)
    employees.value = response.Value.filter(
      (e) => !props.performersEstimated.some((p) => p.Id == e.Id),
    );
};
/**Удаление сотрудника из массива */
const removePerformer = (performerId: number) => {
  const performerIndex = props.performersEstimated.findIndex((p) => p.Id == performerId);
  if (performerIndex != -1) props.performersEstimated.splice(performerIndex, 1);
};
/**Установка оценки текущим пользователем */
const setCurrentUserEstimate = (estimate: number) => {
  const userEstimate = new PerformerEstimatedModel({
    Id: CurrentUser.Id,
    FirstName: CurrentUser.FirstName,
    LastName: CurrentUser.LastName,
    MiddleName: CurrentUser.MiddleName,
    AvatarColor: CurrentUser.AvatarColor,
    Foto: CurrentUser.Foto,
    Estimate: estimate,
    DateUpsert: new Date(),
  });

  props.performersEstimated.push(userEstimate);
  if (props.canUpsertFinalEstimate) {
    finalEstimate.value = userEstimate;
  }

  changeMode(TaskTimeEstimateModeEnum.View);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (finalEstimate.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createVNode(TaskTimeEstimateLi, {
            taskId: __props.taskId,
            isEditTime: __props.userAccess.IsProjectAdmin || isOwner.value,
            "performer-estimate": finalEstimate.value
          }, null, 8, ["taskId", "isEditTime", "performer-estimate"])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_3,
          (__props.performersEstimated.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.performersEstimated, (performerEstimated) => {
                  return (_openBlock(), _createBlock(TaskTimeEstimateLi, {
                    "performer-estimate": performerEstimated,
                    key: performerEstimated.Id,
                    taskId: __props.taskId,
                    isEditTime: isUsersEditDisabled.value || !__props.canUpsertFinalEstimate || isOwner.value,
                    onRemovePerformer: removePerformer
                  }, null, 8, ["performer-estimate", "taskId", "isEditTime"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (mode.value === _unref(TaskTimeEstimateModeEnum).View)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (showAddButton.value)
                  ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                      key: 0,
                      class: _normalizeClass({ 'task-time-estimate__button-add-grade': !__props.canInvite }),
                      size: _unref(TirPmButtonSizeEnum).Small,
                      variant: changeButtonVariant.value,
                      "is-disabled": __props.isDisabled && !__props.isEstimate,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeMode(_unref(TaskTimeEstimateModeEnum).Add)))
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(PlusIcon))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(__props.canUpsertFinalEstimate ? 'Выставить окончательную оценку' : 'Добавить оценку'), 1)
                      ]),
                      _: 1
                    }, 8, ["class", "size", "variant", "is-disabled"]))
                  : _createCommentVNode("", true),
                (!__props.isDisabled && allowInvite.value)
                  ? (_openBlock(), _createBlock(_unref(EmployeeMultiselect), {
                      key: 1,
                      modelValue: invitedEmployees.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((invitedEmployees).value = $event)),
                      ref_key: "$employeeMultiselect",
                      ref: $employeeMultiselect,
                      popoverWidth: "32.5rem",
                      popoverPosition: { left: '$el:width - 32.5rem', bottom: '$el:height + 0.25rem' },
                      employees: employees.value,
                      onOpen: onOpenMultiselect
                    }, {
                      target: _withCtx(() => [
                        _createVNode(_unref(TirPmButton), {
                          size: _unref(TirPmButtonSizeEnum).Small,
                          variant: _unref(TirPmButtonVariantEnum).LinkState,
                          "is-disabled": __props.isDisabled
                        }, {
                          leftSlot: _withCtx(() => [
                            _createVNode(_unref(UserPlusIcon))
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" Пригласить для оценки ")
                          ]),
                          _: 1
                        }, 8, ["size", "variant", "is-disabled"])
                      ]),
                      optionsContentFooter: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_unref(TirPmButton), {
                            size: _unref(TirPmButtonSizeEnum).Small,
                            variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                            "is-disabled": inviteButtonDisabled.value,
                            "is-loading": isInviteLoading.value,
                            onClick: inviteEstimate
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Пригласить для оценки ")
                            ]),
                            _: 1
                          }, 8, ["size", "variant", "is-disabled", "is-loading"]),
                          _createVNode(_unref(TirPmButton), {
                            size: _unref(TirPmButtonSizeEnum).Small,
                            variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                            onClick: closeEmployeeMultiselect
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Отмена ")
                            ]),
                            _: 1
                          }, 8, ["size", "variant"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "employees"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(TaskTimeEstimateInput, {
                key: 2,
                class: "task-time-estimate__input",
                isDisabled: __props.isDisabled,
                taskId: __props.taskId,
                canUpsertFinalEstimate: __props.canUpsertFinalEstimate,
                onUpsert: setCurrentUserEstimate,
                onCancel: _cache[2] || (_cache[2] = ($event: any) => (changeMode(_unref(TaskTimeEstimateModeEnum).View)))
              }, null, 8, ["isDisabled", "taskId", "canUpsertFinalEstimate"]))
        ], 64))
  ]))
}
}

})